<script>
import { authComputed } from '@state/helpers'

// import NotificationIcon from './TheNotificationIcon'
export default {
  components: {
    // NotificationIcon,
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      searchQuery: '',
      showSearchList: Object.freeze({
        orders: {
          placeholder: '搜尋訂單：輸入使用人姓名、手機號碼或訂單編號',
        },
        member: {
          placeholder: '搜尋客戶：請輸入客戶姓名或是手機號碼',
        },
      }),
    }
  },

  computed: {
    ...authComputed,
    currentUserName() {
      return (
        this.currentUser &&
        `${this.currentUser.firstName} ${this.currentUser.lastName}`
      )
    },
    showSearch() {
      return this.showSearchList[this.$route.name]
    },
  },
  created() {
    this.searchQuery = this.$route.query.search || ''
  },
  methods: {
    emitToggle() {
      this.$emit('toggle')
    },
    onClickDropdown(command) {
      this.$router.push({ name: command })
    },
    goToSearchPage() {
      this.$router.push({
        name: this.$route.name,
        query: { search: this.searchQuery },
      })
    },
  },
}
</script>

<template>
  <el-header :class="$style.header">
    <div :class="$style['header-left']">
      <!-- <BaseIcon :name="collapsed ? 'bars' : 'bars'" :class=" $style.toggler" @click="emitToggle" /> -->
      <el-input
        v-if="showSearch"
        v-model.trim.lazy="searchQuery"
        :class="$style.search"
        :placeholder="showSearch.placeholder"
        @keyup.native.enter="goToSearchPage"
      >
        <BaseIcon slot="prefix" name="search" class="el-input__icon" />
      </el-input>
    </div>
    <div :class="$style['header-right']">
      <template v-if="currentUserRoutes && currentUserRoutes.includes('check-in')">
        <span
          welcome-guide-title="前台接待／報到"
          welcome-guide-intro="商店月曆總覽、手機號碼查詢訂單、掃描 QR Code 報到"
          :class="$style.action"
        >
          <router-link :to="{ name: 'check-in' }">
            <el-button type="text">
              前台接待
              <BaseIcon name="concierge-bell" />
            </el-button>
          </router-link>
        </span>
        <!--[下一階段 TODO:]  <NotificationIcon :class="$style.action" /> -->
        <el-divider direction="vertical" />
      </template>
      <span :class="$style.action">
        <el-link :href="merchantUrl" target="_blank">
          查看專屬訂購頁
          <BaseIcon name="external-link" />
        </el-link>
      </span>
      <el-divider direction="vertical" />
      <el-dropdown :class="$style.action" trigger="click" @command="onClickDropdown">
        <span>
          {{ currentUserName }}
          <BaseIcon name="angle-down" />
        </span>

        <el-dropdown-menu slot="dropdown" :class="$style['action-menu']">
          <el-dropdown-item command="logout">
            登出
            <BaseIcon name="sign-out" />
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </el-header>
</template>

<style lang="scss" module>
@import '@design';
.header {
  @include layer-elevation(8);

  position: absolute;
  z-index: $layer-header-z-index;
  display: flex;
  justify-content: space-between;
  width: calc(100% - #{$size-sidebar-width});
  background-color: white;
  &-left,
  &-right {
    display: flex;
    align-items: center;
  }
  &-left {
    flex-basis: 50%;
    justify-content: center;
  }
}
.toggler {
  margin-right: 20px;
}
.action {
  margin: 0 12px;
}
.search :global(.el-input__inner) {
  border-top-color: transparent;
  border-right-color: transparent;
  border-left-color: transparent;
}
</style>
